var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'loading': _vm.loading}},[_c('div',{staticClass:"products row"},_vm._l((this.products),function(item){return _c('shop-item',{key:item.id,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }